import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import HospitalUtils from "../classes/HospitalUtils";
import TextView from "./TextView";
import InvoiceDayCell from "./InvoiceDayCell";
import { BuildContext } from "../classes/BuildContext";

type _InvoiceDayViewOnDaySelected = (day: number) => void;

export interface InvoiceDayViewProps extends BaseUIProps {
  key?: string;
  selectedDay?: number;
  onDaySelected: _InvoiceDayViewOnDaySelected;
}

class _InvoiceDayViewState extends ObservableComponent<InvoiceDayViewProps> {
  static defaultProps = { selectedDay: 0, onDaySelected: null };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: InvoiceDayViewProps) {
    super(props);

    this.initState();
  }
  public get selectedDay(): number {
    return this.props.selectedDay;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["selectedDay"], this.rebuild);
  }
  public componentDidUpdate(prevProps: InvoiceDayViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.selectedDay !== this.props.selectedDay) {
      this.fire("selectedDay", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisAlignment: ui.MainAxisAlignment.start,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        TextView({
          data: "Invoice Date",
          style: new ui.TextStyle({ fontWeight: ui.FontWeight.w600 }),
          className: "x6f7 hc",
          key: "0",
        }),
        HospitalUtils.to(4).expand((rowIndex) => [
          ui.Row({
            mainAxisAlignment: ui.MainAxisAlignment.spaceEvenly,
            children: [
              HospitalUtils.to(7).expand((item) => [
                InvoiceDayCell({
                  day: (rowIndex - 1) * 7 + item,
                  selectedDay: this.selectedDay,
                  onTapDay: (selectedDay) => {
                    this.invoiceDateHandler(selectedDay, item, rowIndex);
                  },
                  key: item?.toString(),
                }),
              ]),
            ],
            className: "x9fe hc h",
            key: rowIndex?.toString(),
          }),
        ]),
      ],
      className: ui.join(this.props.className, "InvoiceDayView x40b hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public invoiceDateHandler = (
    selectedDay: number,
    item: number,
    rowIndex: number
  ): void => {
    this.onDaySelected(selectedDay);
  };
  public get onDaySelected(): _InvoiceDayViewOnDaySelected {
    return this.props.onDaySelected;
  }
}
export default function InvoiceDayView(props: InvoiceDayViewProps) {
  return React.createElement(_InvoiceDayViewState, {
    ..._InvoiceDayViewState.defaultProps,
    ...props,
  });
}
